import { useState, useEffect } from 'react';
import { auth } from '../apiClient';

// Читаем закешированного user из localStorage синхронно —
// это позволяет меню отрисоваться мгновенно после логина без ожидания auth.me()
const getCachedUser = () => {
  try {
    const raw = localStorage.getItem('cachedUser');
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

export const useCurrentUser = () => {
  const [user, setUser] = useState(getCachedUser);
  const [isLoading, setIsLoading] = useState(!getCachedUser());
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const { data: currentUser } = await auth.me();
        setUser(currentUser);
        // Обновляем кеш свежими данными с сервера
        localStorage.setItem('cachedUser', JSON.stringify(currentUser));
      } catch (error) {
        setError(error);
        console.error("Error fetching user:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchUser();
  }, []);

  return { user, isLoading, error };
};

export const canSeeModule = (user, moduleName) => {
  if (!user) return false;
  if (user.role === 'admin') return true;
  if (user.role_type === 'inspector') return true;
  return user[moduleName] === true && user.assigned_project_ids?.length > 0;
};

export const canSeeCorrespondence = (user) => canSeeModule(user, 'module_correspondence');
export const canSeeConstructionControl = (user) => canSeeModule(user, 'module_construction_control');
export const canSeeDocumentation = (user) => canSeeModule(user, 'module_documentation');
export const canSeeSchedule = (user) => canSeeModule(user, 'module_schedule');